import React from "react"

export const roleContext = React.createContext(null);
